import { API_ROUTES } from '@shared/api-utils';
import { setRegistrationAuthPending } from './registrationAuthResume';

const OTT_QUERY_PARAM = 'ott';
const REDIRECT_URI_QUERY_PARAM = 'redirectUri';

function buildRegistrationLoginUrl(baseUrl: string, ott: string, redirectUri: string): string {
  const loginUrl = new URL(`${baseUrl}${API_ROUTES.MY_ACCOUNT.PLAYER_AUTH.LOGIN}`);
  loginUrl.searchParams.set(OTT_QUERY_PARAM, ott);
  loginUrl.searchParams.set(REDIRECT_URI_QUERY_PARAM, redirectUri);
  return loginUrl.href;
}

function redirectToRegistrationLogin(baseUrl: string, ott: string, redirectUri: string): void {
  setRegistrationAuthPending();
  window.location.href = buildRegistrationLoginUrl(baseUrl, ott, redirectUri);
}

export { buildRegistrationLoginUrl, redirectToRegistrationLogin };
